import React from "react";
import { InputNumber, Input } from "antd";
import trim from "lodash/trim";
import toString from "lodash/toString";
import classNames from "classnames";
import WeaHelpfulTip from "../wea-helpful-tip";
import "./index.less";
import middleware from "../../middleware";

const maxNumber = 999999999999999;

class Main extends React.Component {
  static defaultProps = {
    max: maxNumber
  };

  onBlur(e) {
    this.props.onBlur && this.props.onBlur(e.target.value);
  }

  render() {
    let { value, precision } = this.props;
    const {
      viewAttr,
      style,
      hasBorder,
      underline,
      tip,
      hasInput,
      alignRight,
      helpfulTip,
      helpfulTipProps,
      className = ""
    } = this.props;
    const req = classNames({
      required:
        (viewAttr === 3 || viewAttr === "3") &&
        trim(toString(value)).length === 0
    });

    const readonly = classNames({
      border: hasBorder,
      underline: underline
    });
    if (!isNaN(Number(precision))) {
      value = Number(value).toFixed(precision);
      // console.log(value, precision);
    }
    if (viewAttr == "1") {
      if (hasInput) {
        const textAlign = classNames({
          right: alignRight
        });
        return (
          <div className={`wea-input-number ${className}`} style={style}>
            <Input
              className={`has-input ${textAlign}`}
              value={value}
              readOnly
            />
            {helpfulTip && (
              <WeaHelpfulTip
                style={{ position: "absolute", right: -31, top: 4 }}
                title={helpfulTip}
                {...helpfulTipProps}
              />
            )}
          </div>
        );
      }
      return (
        <div
          className={`wea-field-readonly ${readonly} ${this.props.className ||
            ""}`}
          style={style}
        >
          <span
            className="child-item wdb"
            dangerouslySetInnerHTML={{ __html: value }}
          />
          {helpfulTip && (
            <WeaHelpfulTip
              style={{ position: "absolute", right: -31, top: 4 }}
              title={helpfulTip}
              {...helpfulTipProps}
            />
          )}
        </div>
      );
    }

    return (
      <div className={`wea-input-number ${req} ${className}`} style={style}>
        <InputNumber
          {...this.props}
          precision={this.props.precision || 0}
          onBlur={this.onBlur.bind(this)}
        />
        {tip && (
          <div
            className="input-tip"
            style={{ marginLeft: 14 }}
            dangerouslySetInnerHTML={{ __html: tip }}
          />
        )}
        {helpfulTip && (
          <WeaHelpfulTip
            style={{ position: "absolute", right: -31, top: 4 }}
            title={helpfulTip}
            {...helpfulTipProps}
          />
        )}
      </div>
    );
  }
}

const Com = middleware(Main, "WeaInputNumber");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-input-number/index.js